export default __webpack_public_path__ + "static/media/womanWithLaptop.7131aca6.svg";